import React, { useState } from "react";
import { Box, TextField, Button, Typography } from "@mui/material";
import { useAuth } from "../../context/AuthContext";
import Logo from "../../assets/logoazul.png";

export default function LoginForm({ onSwitch }) {

    const { login } = useAuth();

    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [loading, setLoading] = useState(false);

    async function handleSubmit(e) {
        e?.preventDefault(); // evita reload do form
        if (loading) return;

        setLoading(true);

        const res = await login(email, password);

        if (!res.ok) {
            alert("Email ou senha inválidos.");
            setLoading(false);
            return;
        }

        const loggedUser = JSON.parse(localStorage.getItem("emmaUser"));

        if (loggedUser?.role === "admin") {
            window.location.href = "/admin";
        } else {
            window.location.href = "/";
        }
    }

    return (
        <Box component="form" onSubmit={handleSubmit}>
            <img src={Logo} alt="logo" style={{ width: 150, marginBottom: 20 }} />

            <Typography variant="h5" sx={{ fontWeight: 700, textAlign: "start" }}>
                Seja bem-vindo ao Emma
            </Typography>

            <Typography sx={{ mt: 1, mb: 3, opacity: 0.6, textAlign: "start" }}>
                Entre na sua conta
            </Typography>

            <TextField
                fullWidth
                placeholder="Email"
                margin="normal"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                sx={{
                    "& .MuiInputBase-input::placeholder": { color: "#b5b5b5", opacity: 1 },
                }}
            />

            <TextField
                fullWidth
                type="password"
                placeholder="Senha"
                margin="normal"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                sx={{
                    "& .MuiInputBase-input::placeholder": { color: "#b5b5b5", opacity: 1 },
                }}
            />

            <Button
                fullWidth
                type="submit"   // <-- importante
                variant="contained"
                disabled={loading}
                sx={{
                    mt: 3,
                    py: 1.4,
                    fontSize: 16,
                    borderRadius: "12px",
                    background: "var(--azul)",
                    ":hover": { background: "var(--azul)" },
                    opacity: loading ? 0.7 : 1,
                }}
            >
                {loading ? "Entrando..." : "Entrar"}
            </Button>

            <Typography
                sx={{
                    mt: 3,
                    textAlign: "center",
                    fontSize: 14,
                    cursor: "pointer",
                    textDecoration: "underline",
                    opacity: 0.8,
                }}
                onClick={onSwitch}
            >
                Criar uma nova conta
            </Typography>
        </Box>
    );
}
